<template>
  <div class="notice-container">
    <div class="header">
      <h2>用户信息列表</h2>
    </div>

  <!-- 用户列表表格 -->
    <el-table :data="userList" border style="width: 100%" v-loading="loading">
      <el-table-column type="index" label="序号" width="80"> </el-table-column>
      <el-table-column prop="phone" label="手机号"></el-table-column>
      <el-table-column prop="id_card" label="身份证号"></el-table-column>
      <el-table-column
        prop="create_time"
        label="注册时间"
        width="180"
      ></el-table-column>
      <el-table-column label="操作" width="200" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" type="danger" @click="handleDelete(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>

  </div>
</template>

<script>
import { getInfo } from "@/api";
export default {
  name: "Notice",
  data() {
    return {
      loading: false, // 加载状态标志
      userList: [], // 用户列表数据
      currentPage: 1, // 当前页码
      pageSize: 20, // 每页显示条数
      total: 0, // 总记录数
    };
  },
  // 组件创建时执行
  created() {
    this.getUserList(); // 获取用户列表数据
  },
  methods: {
    // 获取用户列表数据
    getUserList() {
      this.loading = true; // 显示加载状态
      // 调用API接口获取数据
      getInfo({
        model: "user", // 模型名称
        condition: {}, // 查询条件
        page: this.currentPage, // 当前页码
        pagesize: this.pageSize, // 每页条数
      }).then((res) => {
        if (res.status == 200) {
          this.userList = res.data.data; // 设置用户列表数据
          this.total = res.data.page_info.total_size; // 设置总记录数
          this.loading = false; // 隐藏加载状态
        }
      });
    },

    // 删除用户
    handleDelete(row) {
      // 显示确认对话框
      this.$confirm("确认删除该公告?", "提示", {
        type: "warning",
      })
        .then(() => {
          // 用户确认删除
          // 执行删除操作（注意：这里只有提示，没有实际调用删除API）
          this.$message.success("删除成功");
          this.getUserList(); 
        })
        .catch(() => {}); // 用户取消删除时不做处理
    },

    // 分页相关方法
    // 每页显示条数变化时的处理函数
    handleSizeChange(val) {
      this.pageSize = val; // 更新每页显示条数
      this.getUserList(); // 重新获取列表数据
    },
    // 当前页变化时的处理函数
    handleCurrentChange(val) {
      this.currentPage = val; // 更新当前页码
      this.getUserList(); // 重新获取列表数据
    },
  },
};
</script>

<style scoped>
.notice-container {
  padding: 20px;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.pagination {
  margin-top: 20px;
  text-align: right;
}

.el-tag {
  min-width: 60px;
  text-align: center;
}
</style>